import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ControlType } from "@cotecna/dynamic-view-engine";

@Component({
    selector: "im-additional-info-dialog",
    templateUrl: "./additional-info-dialog.component.html",
    styleUrls: ["./additional-info-dialog.component.scss"],
    standalone: false
})
export class AdditionalInfoDialogComponent implements OnInit {
  @ViewChild("form") public form: HTMLFormElement;

  public fieldValueLenght: number = Math.max();

  public constructor(
    private dialogRef: MatDialogRef<AdditionalInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}

  public ngOnInit(): void {
    if (this.dialogData.type == ControlType.Dropdown) {
      this.fieldValueLenght = 50;
    }
  }

  public onFieldNameChange(fieldName: string) {
    this.dialogData.fieldName = fieldName;
    const other = this.dialogData?.availablePrefilledOthers?.find(
      (o) => o.key.toUpperCase() === fieldName.toUpperCase(),
    );
    if (other) this.dialogData.value = other.value;
    const otherSelected = this.dialogData?.others?.find(
      (o) => o.key.toUpperCase() === fieldName.toUpperCase(),
    );
    if (otherSelected) {
      this.form.controls["fieldName"].setErrors({ incorrect: true });
    }
  }

  public onValueChange(event) {
    this.dialogData.value = event;
  }

  public save() {
    this.dialogRef.close({
      data: {
        fieldname: this.dialogData.fieldName,
        value: this.dialogData.value,
      },
    });
  }

  public cancel() {
    this.dialogRef.close();
  }
}
